const PASSWORD_ALPHABET =
  "abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789";

/** Пароль для ссылки на ответы (8+ символов). */
export function generateSharePassword(length = 12): string {
  const size = Math.max(8, length);
  const values = new Uint32Array(size);
  crypto.getRandomValues(values);

  let password = "";
  for (let index = 0; index < size; index += 1) {
    password += PASSWORD_ALPHABET[values[index]! % PASSWORD_ALPHABET.length];
  }
  return password;
}

/** ISO для API из значения `<input type="datetime-local">`. */
export function datetimeLocalToIso(value: string): string | null {
  if (!value.trim()) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
}

/** ISO для API: конец выбранного дня (локальное время). */
export function dateLocalToIsoEndOfDay(value: string): string | null {
  if (!value.trim()) return null;
  const date = new Date(`${value}T23:59:59`);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
}

export function toDateLocalValue(date: Date): string {
  const pad = (part: number) => String(part).padStart(2, "0");
  return [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate()),
  ].join("-");
}

/** Значение для `<input type="date">`: +days от сегодня. */
export function defaultExpiresDateLocal(days = 30): string {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return toDateLocalValue(date);
}

export function minExpiresDateLocal(): string {
  return toDateLocalValue(new Date());
}

export function maxExpiresDateLocal(): string {
  const date = new Date();
  date.setDate(date.getDate() + 365);
  return toDateLocalValue(date);
}

/** Значение для datetime-local: +days от сейчас. */
export function defaultExpiresAtLocal(days = 30): string {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return toDatetimeLocalValue(date);
}

export function toDatetimeLocalValue(date: Date): string {
  const pad = (part: number) => String(part).padStart(2, "0");
  return (
    [date.getFullYear(), pad(date.getMonth() + 1), pad(date.getDate())].join(
      "-",
    ) + `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
}

export function maxExpiresAtLocal(): string {
  const date = new Date();
  date.setDate(date.getDate() + 365);
  return toDatetimeLocalValue(date);
}

export type ShareExpiresPreset = 1 | 7 | 30 | "custom";

export function resolveShareExpiresAtIso(
  preset: ShareExpiresPreset,
  customDate: string,
): string | null {
  if (preset === "custom") {
    return dateLocalToIsoEndOfDay(customDate);
  }
  return datetimeLocalToIso(defaultExpiresAtLocal(preset));
}
